import { state, props } from 'cerebral/tags'
import { when, set, wait } from 'cerebral/operators'
import expandNode from './expandNode'

export default [
  when(state`media.dragging`),
  {
    true: [
      set(state`node.drop.path`, props`path`),
      set(state`node.drop.id`, state`${props`path`}.id`),
      when(
        state`node.drop.id`,
        state`node.selectedNode.id`,
        (current, next) => current === next
      ),
      {
        true: [],
        false: [set(state`media.canDropMedia`, true)]
      },
      wait(600),
      {
        continue: [
          when(
            state`node.drop.path`,
            props`path`,
            (node, path) => node === path
          ),
          {
            true: [...expandNode],
            false: []
          }
        ]
      }
    ],
    false: []
  }
]



// WEBPACK FOOTER //
// ./src/modules/Node/chains/onNodeEnter.js